import { FC, FormEventHandler, ReactNode } from "react";
import { Box, Button, CircularProgress, Grid, Paper, Typography } from "@mui/material";

export const FormContainer: FC<{ onSubmit: FormEventHandler<HTMLFormElement> }> = ({ onSubmit, children }) => (
  <Box
    component="form"
    display="flex"
    flexDirection="column"
    gap={2}
    sx={{ maxWidth: 1100, py: 2 }}
    autoComplete="off"
    onSubmit={onSubmit}
  >
    {children}
  </Box>
);

type FormHeaderProps = {
  section: string;
  title: ReactNode;
  isSubmitting: boolean;
};

// Sticky top bar with breadcrumb, title, extra controls (children) and the submit button.
export const FormHeader: FC<FormHeaderProps> = ({ section, title, isSubmitting, children }) => (
  <Paper
    variant="outlined"
    sx={{ position: "sticky", top: 0, zIndex: 2, px: 2, py: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}
  >
    <Box>
      <Typography variant="caption" color="text.secondary">{section}</Typography>
      <Typography variant="h6" sx={{ lineHeight: 1.2 }}>{title}</Typography>
    </Box>
    <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
      {children}
      <Button type="submit" variant="contained" disabled={isSubmitting} sx={{ minWidth: 96 }}>
        {isSubmitting ? <CircularProgress size={22} color="inherit" /> : "Lagre"}
      </Button>
    </Box>
  </Paper>
);

export const FormSection: FC<{ title: string }> = ({ title, children }) => (
  <Paper variant="outlined" sx={{ p: 2 }}>
    <Typography variant="subtitle1" sx={{ fontWeight: 500, mb: 2 }}>{title}</Typography>
    <Grid container spacing={2}>
      {children}
    </Grid>
  </Paper>
);
